import { media } from '@app/ui'
import theme from '@app/ui/theme'
import styled from 'styled-components'

interface HeaderContainerProps {
  center?: boolean
}

export const MobileHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 18px;
  margin-right: 6px;
  margin-left: 6px;
  margin-bottom: 11px;
  elevation: 999;
  height: auto;
  align-items: center;

  & > img {
    margin-left: 25px;
    height: 70px;
  }
`

export const FilterButton = styled.button`
  background-color: ${theme.colors.dark};
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 9px;
  padding-bottom: 9px;
  border-radius: ${theme.borderRadius}px;
  display: flex;
  font-size: 16px;
  white-space: nowrap;
  font-weight: 500;
  color: ${theme.colors.white};
  font-weight: 500;
  align-items: center;
  justify-content: center;
  margin-top: 0px;
  cursor: pointer;
  user-select: none;
  &:active {
    opacity: 0.7;
  }
`

interface FilterCardProps {
  width?: number | string
  lessMargin?: boolean
}

export const MobileFilterCard = styled.div<FilterCardProps>`
  box-shadow: 0 0px 4px 0 ${theme.colors.dark1};
  transition: 0.3s;
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${theme.colors.white};
  border-radius: 5px;
  max-width: 528px;
  flex-direction: row;
  margin-bottom: 12px;
  & > input {
    margin: 0 6px;
    padding: 0;
    border: none;
    outline: none;
    height: 40px;
    text-align: left;
    font-size: 16px;
    font-weight: 500;
    align-self: flex-start;
    background-color: transparent;
  }
  & > input::placeholder {
    color: #333;
  }
`

export const EvaluationCard = styled.div<FilterCardProps>`
  box-shadow: 0 0px 4px 0 ${theme.colors.dark1};
  transition: 0.3s;
  width: ${(props) => props.width ?? 200}px;
  height: 80px;
  display: flex;
  flex: 1;
  justify-content: flex-start;
  align-items: center;
  background-color: ${theme.colors.white};
  border-radius: 21px;
  max-width: 340px;
  ${media.tablet} {
    width: 100%;
    max-width: 100%;
  }
  & > input {
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    height: 40px;
    width: 240px;
    text-align: left;
    padding-left: 5px;
    font-size: 16px;
    font-weight: 500;
    align-self: flex-start;
    background-color: transparent;
  }
  & > input::placeholder {
    color: #333;
  }
`

export const EvaluationCardIcon = styled.div`
  width: 50px;
`

export const CardIconsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const FilterCardIcon = styled.div`
  margin-right: 24px;
`

export const FilterCardIconSearch = styled.div`
  margin-right: 24px;
`

export const RatingNameInput = styled(EvaluationCard)<{
  width?: string | number
}>`
  display: flex;
  justify-content: flex-start;
  height: 40px;
  border-radius: ${theme.borderRadius}px;
  border: 1px solid ${theme.colors.dark1};
  box-shadow: none;
  max-width: 420px;
`

export const RatingNameButton = styled.button`
  height: 40px;
  background-color: ${theme.colors.secondary2};
  border-radius: ${theme.borderRadius}px;
  border: 1px solid ${theme.colors.secondary2};
  color: ${theme.colors.white};
  max-width: 420px;
  width: 100%;
  cursor: pointer;
`

export const RatingInputSave = styled.div`
  width: 100%;
`
